// extracted by mini-css-extract-plugin
export default {"searchBox":"MapPage_searchBox__ElLKT","select":"MapPage_select__VMlPL","styledTable":"MapPage_styledTable__EQfxM","addButton":"MapPage_addButton__6tZBt","url":"MapPage_url__-xUPD"};